// extracted by mini-css-extract-plugin
export default {"dateRow":"InstitutionForm_dateRow__vvUnk","dateLabel":"InstitutionForm_dateLabel__08DTy","dateInput":"InstitutionForm_dateInput__RJWQc"};